import clsx from "clsx";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks";
import { GetFileObjectById, resetGetFileObjectByIdStatus } from "../../../../objectStorage/slice";
import { ButtonComponent } from "../../../../ui/molecules/button/newButton";
import { Calendar } from "../../../../ui/molecules/calendar";
import CheckboxGroup from "../../../../ui/molecules/CheckBoxGroup";
import Input from "../../../../ui/molecules/input";
import InputMultiSearch from "../../../../ui/molecules/input/InputMultiSearch";
import { MadfarmInput } from "../../../../ui/molecules/input/newInput";
import { ProtocolSearch } from "../../../../ui/molecules/ProtocolSearch";
import { MadfarmStaticSelect } from "../../../../ui/molecules/select/newSelect/static";
import TextArea from "../../../../ui/molecules/textArea";
import { PopupForm } from "../../../../ui/organisms/popupForm";
import { DeliveryManagementType, OptionType, countries, departureMeansOptions, regioniList } from "../../../../utils";
import { FindMe, resetfindMeStatusIdle } from "../../../users/slice";
import { AddObjectPopupEntry } from "../../popup/addObjectEntry";
import { DepartureProtocolUpdate, DepartureProtocolUploadAttachmentFile, GetAllDepartureProtocolObjects, GetDepartureProtocolById, resetDepartureProtocolErrors, resetDepartureProtocolUpdateStatus, resetDepartureProtocolUploadAttachmentFileStatus, resetDepartureProtocolValidationStatus, resetGetAllDepartureProtocolObjectsStatus, setFileToUpdate, setPPFileAndAtt, setUpdateCorriere, setUpdateDataBolgetta, setUpdateDataReceive, setUpdateDataRicezioneCompiutaGiacenza, setUpdateDataRitornoErratoIndirizzo, setUpdateNumRaccomandata, setUpdateNumeroRaccomandataErratoIndirizzo, setUpdatePEC, setUpdatePPCustomerIds, setUpdatePPCustomersNotRegistered, setUpdatePPDepartureChannel, setUpdatePPDepartureObjectId, setUpdatePPHeadquarter, setUpdatePPLinkExistingProtocol, setUpdatePPNation, setUpdatePPObjectSpec, setUpdatePPRegion, setUpdatePPTotalPage, setUpdatePostaElettronica, setUpdateRaccomandataAr, setUpdateRaccomandataMano, setUpdatedFile, setUpdatedPPAttachmentFile, setUpdatepPSender } from "../slice";

export function EditDepartureLeft() {
    const dispatch = useAppDispatch()
    const [showPopup, setShowPopup] = useState<boolean>(false)
    const [loadPdf, setLoadPdf] = useState<boolean>(false)
    const objectStorageState = useAppSelector(state => state.objectStorage)
    const [selectedDeliveries, setSelectedDeliveries] = useState<DeliveryManagementType[]>([])
    const departureProtocolState = useAppSelector(state => state.departureProtocol)
    const [objects, setObjects] = useState<OptionType[]>([])
    const [file, setFile] = useState<File | null>(null)
    const [officeSot, setOfficeSot] = useState<OptionType[]>([])
    const userState = useAppSelector(state => state.users)

    let formData = new FormData();
    let attachmentFormdata = new FormData();

    useEffect(() => {
        dispatch(FindMe())
    }, [])

    useEffect(() => {
        if (userState.findMeStatus === 'successfully') {
            dispatch(resetfindMeStatusIdle())
            if (userState.findMeResponse.headQuarterInfo !== null && userState.findMeResponse.headQuarterInfo !== undefined) {
                const newOption: OptionType = {
                    value: userState.findMeResponse.headQuarterInfo.id,
                    label: userState.findMeResponse.headQuarterInfo.code
                };

                setOfficeSot(prevOptions => {
                    const optionExists = prevOptions.some(option => option.value === newOption.value);
                    if (!optionExists) {
                        return [...prevOptions, newOption];
                    }
                    return prevOptions;
                });
            }

            if (userState.findMeResponse.office !== null && userState.findMeResponse.office !== undefined) {
                const newOption: OptionType = {
                    value: userState.findMeResponse.office,
                    label: userState.findMeResponse.office
                };

                setOfficeSot(prevOptions => {
                    const optionExists = prevOptions.some(option => option.value === newOption.value);
                    if (!optionExists) {
                        return [...prevOptions, newOption];
                    }
                    return prevOptions;
                });
            }
        }
    }, [userState.findMeStatus])

    useEffect(() => {
        dispatch(resetDepartureProtocolErrors())
        dispatch(GetAllDepartureProtocolObjects())
    }, [])

    useEffect(() => {
        setFile(departureProtocolState.fileToUpdate as File)
    }, [departureProtocolState.fileToUpdate])

    useEffect(() => {
        if (departureProtocolState.getAllDepartureProtocolObjectsStatus === 'successfully' &&
            departureProtocolState.getAllDepartureProtocolObjectsResponse !== undefined
        ) {
            dispatch(resetGetAllDepartureProtocolObjectsStatus())
            const data = departureProtocolState.getAllDepartureProtocolObjectsResponse
            const newObjects: OptionType[] = data.map(d => {
                return { value: d.id, label: `${d.description} [${d.coding}]` } as OptionType
            })
            setObjects(newObjects)
        }
    }, [departureProtocolState.getAllDepartureProtocolObjectsStatus])

    useEffect(() => {
        if (departureProtocolState.departureProtocolValidationStatus === 'successfully') {
            dispatch(resetDepartureProtocolValidationStatus())
            formData.delete('file')
            if (file !== null && file !== undefined) {
                formData.append('file', file)
            }

            formData.append('departureProtocolUpdateDTO', JSON.stringify(departureProtocolState.departureProtocolUpdateRequest))
            // for(const attF of departureProtocolState.departureProtocolUpdateFileAndAtt) {
            //     attachmentFormdata.delete('file')
            //     attachmentFormdata.append('file', attF.file)
            //     attachmentFormdata.append('attachmentFileDTO', JSON.stringify({attachmentId: attF.attachmentId}))
            //     dispatch(DepartureProtocolUploadAttachmentFile({data: attachmentFormdata, id: departureProtocolState.departureProtocolIdToUpdate}))
            // }
            dispatch(DepartureProtocolUpdate({ body: formData, id: departureProtocolState.departureProtocolIdToUpdate }))
        }
    }, [departureProtocolState.departureProtocolValidationStatus])

useEffect(() => {
    if (departureProtocolState.departureProtocolUpdateStatus === 'successfully') {
        dispatch(resetDepartureProtocolUpdateStatus())
        dispatch(setFileToUpdate(null))

        if (departureProtocolState.departureProtocolUpdateResponse != null) {
            dispatch(GetFileObjectById(departureProtocolState.departureProtocolUpdateResponse))
        }

        if (departureProtocolState.departureProtocolUpdateFileAndAtt.length > 0) {
            const attF = departureProtocolState.departureProtocolUpdateFileAndAtt[0]
            dispatch(setPPFileAndAtt(departureProtocolState.departureProtocolUpdateFileAndAtt.slice(1)))
            if (attF?.file) {
                attachmentFormdata.delete('file')
                attachmentFormdata.append('file', attF.file)
                attachmentFormdata.append('attachmentFileDTO', JSON.stringify({ attachmentId: attF.attachmentId }))
                dispatch(DepartureProtocolUploadAttachmentFile({ data: attachmentFormdata, id: departureProtocolState.departureProtocolIdToUpdate }))
            }
        }
    }
}, [departureProtocolState.departureProtocolUpdateStatus])

    useEffect(() => {
        if (departureProtocolState.departureProtocolUploadAttachmentFileStatus === 'successfully') {
            dispatch(resetDepartureProtocolUploadAttachmentFileStatus())
            if (departureProtocolState.departureProtocolUpdateFileAndAtt.length > 0) {
                const attF = departureProtocolState.departureProtocolUpdateFileAndAtt[0]
                dispatch(setPPFileAndAtt(departureProtocolState.departureProtocolUpdateFileAndAtt.slice(1)))
                if (attF !== undefined && attF && attF !== null) {
                    if (attF.file !== undefined && attF.file) {
                        attachmentFormdata.delete('file')
                        attachmentFormdata.append('file', attF.file)
                        attachmentFormdata.append('attachmentFileDTO', JSON.stringify({ attachmentId: attF.attachmentId }))
                        dispatch(DepartureProtocolUploadAttachmentFile({ data: attachmentFormdata, id: departureProtocolState.departureProtocolIdToUpdate }))
                    }
                }
            } else {
                dispatch(GetDepartureProtocolById(departureProtocolState.departureProtocolIdToUpdate))
            }
        }
    }, [departureProtocolState.departureProtocolUploadAttachmentFileStatus])

    useEffect(() => {
        if (departureProtocolState.getDepartureProtocolByIdStatus === 'successfully' &&
            departureProtocolState.getDepartureProtocolByIdResponse !== undefined
        ) {
            const data = departureProtocolState.getDepartureProtocolByIdResponse
            dispatch(setUpdatedPPAttachmentFile(data.attachmentFile))
        }
    }, [departureProtocolState.getDepartureProtocolByIdStatus])

    useEffect(() => {
        if (objectStorageState.getFileObjectByIdStatus === 'successfully' &&
            objectStorageState.getFileObjectByIdResponse !== undefined
        ) {
            dispatch(resetGetFileObjectByIdStatus())
            dispatch(setUpdatedFile(objectStorageState.getFileObjectByIdResponse))
        }
    }, [objectStorageState.getFileObjectByIdStatus])


    const handleTypesChange = (value: DeliveryManagementType) => {
        let currentDeliveries = [...selectedDeliveries]
        if (currentDeliveries.includes(value)) {
            currentDeliveries = currentDeliveries.filter(t => t !== value)
        }
        else {
            currentDeliveries.push(value)
        }
        setSelectedDeliveries(currentDeliveries)

        const corriereState = currentDeliveries.includes(DeliveryManagementType.CORRIERE)
        dispatch(setUpdateCorriere(corriereState))

        const raccAManoState = currentDeliveries.includes(DeliveryManagementType.RACC_M)
        dispatch(setUpdateRaccomandataMano(raccAManoState))

        const postaElettState = currentDeliveries.includes(DeliveryManagementType.POST_E)
        dispatch(setUpdatePostaElettronica(postaElettState))

        const pecState = currentDeliveries.includes(DeliveryManagementType.PEC)
        dispatch(setUpdatePEC(pecState))

        const raccARState = currentDeliveries.includes(DeliveryManagementType.RACC_AR)
        dispatch(setUpdateRaccomandataAr(raccARState))
    }

    return (
        <div className="pb-6">
            <div className="protocol-header">
                <span className='title'>Modifica protocollo partenza</span>
            </div>
            <div className='protocol-content flex flex-col gap-6'>

                <div className='grid grid-cols-2 gap-4'>
                    {
                        userState.findMeResponse.role === 'admin' ? (
                            <MadfarmInput label='Protocollo' disabled value={departureProtocolState.departureProtocolUpdateRequest.headQuarter} />
                        ) : (
                            <MadfarmStaticSelect
                                label='Protocollo'
                                noOptionsMessage="Nessun protocollo trovato"
                                placeholder={'Seleziona protocollo'}
                                options={officeSot}
                                onChange={(value) => {
                                    //@ts-ignore
                                    const newValue = value ? value.value : null
                                    dispatch(setUpdatePPHeadquarter(newValue))
                                }}
                                disabled
                                defaultValue={departureProtocolState.departureProtocolUpdateRequest.headQuarter}
                                value={departureProtocolState.departureProtocolUpdateRequest.headQuarter}
                            />
                        )

                    }
                    <Calendar
                        label="Data protocollo"
                        errorLabel={departureProtocolState.departureProtocolErrors.protocolDate ? 'Data mancante' : undefined}
                        disabled
                        selected={departureProtocolState.departureProtocolUpdateRequest.protocolDate}
                        onChange={(date) => { }}
                    />
                </div>
                <div className='grid grid-cols-2 gap-4'>
                    <MadfarmStaticSelect
                        label='Nazione'
                        noOptionsMessage="Nessuna nazione trovata"
                        placeholder={'Seleziona nazione'}
                        options={countries}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value ? value.value : null
                            dispatch(setUpdatePPNation(newValue))
                        }}
                        value={departureProtocolState.departureProtocolUpdateRequest.nation}
                    />
                    <MadfarmStaticSelect
                        label='Regione'
                        noOptionsMessage="Nessuna regione trovata"
                        placeholder={'Seleziona regione'}
                        options={regioniList}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value ? value.value : null
                            dispatch(setUpdatePPRegion(newValue))
                        }}
                        value={departureProtocolState.departureProtocolUpdateRequest.region}
                    />
                </div>
                <div className='grid grid-cols-2 gap-4'>
                    <MadfarmInput
                        error={departureProtocolState.departureProtocolErrors.receiver}
                        supportingText={departureProtocolState.departureProtocolErrors.receiver ? 'Mittente mancante' : undefined}
                        label={'Destinatario'}
                        placeholder="Destinatario dei documenti da protocollare"
                        value={departureProtocolState.departureProtocolUpdateRequest.receiver}
                        onChangeText={(text) => dispatch(setUpdatepPSender(text))}
                    />
                    <InputMultiSearch
                        label={'Cliente'}
                        placeholder="Ragione sociale"
                        defaultClientIds={departureProtocolState.departureProtocolUpdateRequest.customerIds}
                        onSelectAddHandler={(res) => dispatch(setUpdatePPCustomerIds(res))}
                    />
                </div>
                <div className='grid grid-cols gap-4'>
                    <MadfarmInput
                        label={'Cliente non presente in archivio'}
                        placeholder="Indicare nel caso di cliente non ancora inserito in archivio"
                        value={departureProtocolState.departureProtocolUpdateRequest.customersNotRegistered}
                        onChangeText={(text) => dispatch(setUpdatePPCustomersNotRegistered(text))}
                    />
                </div>
                <div className="border h-[1px] border-neutral-200" />
                <div className='flex flex-row items-center gap-4'>
                    <div className={clsx("w-full", { "w-[85%]": userState.findMeResponse.role === "admin" })}>
                        <MadfarmStaticSelect
                            label="Oggetto (Da elenco)"
                            noOptionsMessage="Nessun risultato trovato"
                            error={departureProtocolState.departureProtocolErrors.entryObjectId}
                            errorLabel='Oggetto mancante'
                            placeholder={'Seleziona...'}
                            options={objects}
                            value={departureProtocolState.departureProtocolUpdateRequest.departureObjectId}
                            onChange={(value) => {
                                //@ts-ignore
                                const newValue = value ? value.value : null
                                dispatch(setUpdatePPDepartureObjectId(newValue))
                            }}
                        />
                    </div>
                    {
                        userState.findMeResponse.role === 'admin' &&
                        <div className="w-[15%] pt-5">
                            <ButtonComponent
                                variant='outline'
                                color='orange'
                                size='md'
                                iconPosition='off'
                                label='Crea oggetto'
                                onClick={() => setShowPopup(true)}
                                fullWidth
                            />
                        </div>
                    }
                </div>
                <div className='grid grid-cols'>
                    <TextArea
                        label="Specifiche oggetto"
                        placeholder="Integrazione all'oggetto indicato sopra"
                        value={departureProtocolState.departureProtocolUpdateRequest.objectSpec}
                        onChangeText={(text) => dispatch(setUpdatePPObjectSpec(text))}
                    />
                </div>
                <div className="border h-[1px] border-neutral-200" />
                <div className='grid grid-cols-2 gap-4'>
                    <MadfarmInput
                        // error={}
                        // supportingText={}
                        label={'Totale pagine'}
                        placeholder="Specificare numero"
                        // value={}
                        // defaultValue={}
                        value={departureProtocolState.departureProtocolUpdateRequest.totalPage?.toString()}
                        onChangeText={(text) => dispatch(setUpdatePPTotalPage(Number(text)))}
                    />
                    <MadfarmStaticSelect
                        label='Mezzo di partenza'
                        noOptionsMessage="Nessun mezzo di partenza trovato"
                        placeholder={'Seleziona...'}
                        options={departureMeansOptions}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value ? value.value : null
                            dispatch(setUpdatePPDepartureChannel(newValue))
                        }}
                        value={departureProtocolState.departureProtocolUpdateRequest.departureChannel}
                    />
                </div>
                <div className="border h-[1px] border-neutral-200" />
                <span className="input-label" style={{ fontSize: '18px', fontWeight: 600 }}>
                    Aggancia a protocollo esistente
                </span>
                <ProtocolSearch
                    type='entry'
                    defaultValue={departureProtocolState.departureProtocolUpdateRequest.linkExistingProtocol}
                    onSelect={(value) => dispatch(setUpdatePPLinkExistingProtocol(value))}
                />
                <div className="border h-[1px] border-neutral-200" />
                <span className="input-label" style={{ fontSize: '18px', fontWeight: 600 }}>
                    Gestione consegna
                </span>
                <div className='grid grid-row-2 gap-4'>
                    <span className="input-label" style={{ fontSize: '16px', fontWeight: 600 }}>
                        Ricevuta a mezzo:
                    </span>
                    <CheckboxGroup
                        name="tipo_consegna_1"
                        options={Object.values(DeliveryManagementType).splice(0, 5)}
                        selectedValues={selectedDeliveries}
                        onChange={handleTypesChange}
                        optionLabels={{
                            [DeliveryManagementType.PEC]: "Posta Elettronica Certificata",
                            [DeliveryManagementType.RACC_AR]: "Raccomandata A/R",
                            [DeliveryManagementType.CORRIERE]: "Corriere",
                            [DeliveryManagementType.RACC_M]: "Raccomandata a mano",
                            [DeliveryManagementType.POST_E]: "Posta elettronica",
                        }}
                    />
                </div>
                {
                    selectedDeliveries.includes(DeliveryManagementType.RACC_AR) && (
                        <>
                            <div className='grid grid-cols-3 gap-4'>
                                <MadfarmInput
                                    // error={}
                                    // supportingText={}
                                    label="Numero raccomandata"
                                    placeholder="Numero raccomandata..."
                                    value={departureProtocolState.departureProtocolUpdateRequest.numeroRaccomandata}
                                    defaultValue={departureProtocolState.departureProtocolUpdateRequest.numeroRaccomandata}
                                    onChangeText={(text) => { dispatch(setUpdateNumRaccomandata(text)) }}
                                />
                                <Calendar
                                    label="Data Bolgetta"
                                    selected={departureProtocolState.departureProtocolUpdateRequest.dataBolgetta}
                                    onChange={(date) => { dispatch(setUpdateDataBolgetta(date)) }}
                                />
                                <Calendar
                                    label="Data Ricezione Compiuta Giacenza"
                                    selected={departureProtocolState.departureProtocolUpdateRequest.dataRicezioneCompiutaGiacenza}
                                    onChange={(date) => { dispatch(setUpdateDataRicezioneCompiutaGiacenza(date)) }}
                                />
                            </div>
                            <div className='grid grid-cols-2 gap-4'>
                                <Calendar
                                    label="Rispedita per errato indirizzo (Data ritorno)"
                                    selected={departureProtocolState.departureProtocolUpdateRequest.dataRitornoErratoIndirizzo}
                                    onChange={(date) => { dispatch(setUpdateDataRitornoErratoIndirizzo(date)) }}
                                />
                                <MadfarmInput
                                    label="Raccomandata Errato indirizzo"
                                    placeholder="Numero raccomandata..."
                                    value={departureProtocolState.departureProtocolUpdateRequest.numeroRaccomandataErratoIndirizzo}
                                    defaultValue={departureProtocolState.departureProtocolUpdateRequest.numeroRaccomandataErratoIndirizzo}
                                    onChangeText={(text) => { dispatch(setUpdateNumeroRaccomandataErratoIndirizzo(text)) }}
                                />
                            </div>
                        </>
                    )}
                <div className="border h-[1px] border-neutral-200" />
                <div className='grid grid-cols-2 gap-4'>
                    <Calendar
                        label="Data ricezione"
                        selected={departureProtocolState.departureProtocolUpdateRequest.receive}
                        onChange={(date) => { dispatch(setUpdateDataReceive(date)) }}
                    />
                </div>
            </div>
            {
                showPopup && (
                    <PopupForm title='Aggiungi Oggetto' close={() => setShowPopup(false)}>
                        <AddObjectPopupEntry close={() => setShowPopup(false)} />
                    </PopupForm>
                )
            }
        </div >
    )
}